import _ from 'underscore';
import BaseTrackingView from '../../core/baseTrackingView';
import { getCurrentDataLayer } from '../../../home24-shared/tracking/common/helper';
import * as registry from '../../../home24/core/registry';

export default BaseTrackingView.extend({

    initialize: function () {
        this.listenTo(this.model, 'change:simpleSku', this.onSimpleSkuChanged);
    },

    onSimpleSkuChanged: function () {

        var trackingData = this.model.get('trackingData');

        // in case new PDP is not providing tracking data
        if (!trackingData) {
            return;
        }

        this.pushEnhancedArticleImpression(trackingData);
        this.pushLegacyArticleImpression(trackingData);
    },

    pushLegacyArticleImpression: function (trackingData) {
        if (typeof window.dataLayer === 'object') {

            var initialDataLayer = getCurrentDataLayer();

            var legacyArticleImpression = _.extend({}, initialDataLayer, {
                productSimpleSKU: trackingData.sku,
                productName: trackingData.name,
                variantName: trackingData.variant,
                productDeliveryTime: trackingData.deliveryTime,
                productPrice: trackingData.price,
                productIntPrice: Math.round(trackingData.price)
            });

            window.dataLayer.push(legacyArticleImpression);
        }
    },

    pushEnhancedArticleImpression: function (trackingData) {
        if (
            typeof window.dataLayer === 'undefined' ||
            typeof trackingData === 'undefined'
        ) {
            return;
        }

        const {
            name,
            price,
            brand,
            variant,
            category,
            categoryBreadcrumb,
            sku: id,
            deliveryTime: dimension64
        } = trackingData;

        const product = {
            name,
            id,
            price,
            brand,
            variant,
            dimension64
        };

        if (typeof category === 'string') {
            product.category = category;
        }

        if (typeof categoryBreadcrumb === 'string') {
            product.categoryBreadcrumb = categoryBreadcrumb;
        }

        window.dataLayer.push({
            event: 'PDPview',
            ecommerce: {
                currencyCode: registry.get('currencyCode'),
                detail: {
                    products: [{ ...product }]
                }
            }
        });
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/pdp-new/Configuration.js
 **/